












exports.default =
  props:
    filter_item_selected_ids:
      type: Array
      default: -> []

    uncheck_all_items:
      type: Boolean
      default: false

    default_label:
      type: String
      default: 'Tags'

    index:
      type: String
      default: ''

  components:
    filterTagsAutocomplete: require('../autocomplete/filter_tags')

  data: ->
    selected_items: []

  computed:
    dropdown_title: ->
      switch
        when @selected_items.length == 0 then @default_label
        when @selected_items.length == 1 then @selected_items[0].name
        else 'Múltiplas Tags'

  methods:
    itemSelectedItems: (data)->
      @selected_items = data.selected_items
      @$emit 'item-selected-items', data



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/dropdown_multiple_kind/tag_filter.vue